export default {
  title: 'Nav Main'
}

const Template = args => `
  <cradlepoint-nav-main
    json="${args.json}"
    logo="${args.logo}"
    show-contact="${args['show-contact']}"
    show-search="${args['show-search']}"
    show-language-nav="${args['show-language-nav']}"
    show-sign-in="${args['show-sign-in']}"
    alt-mobile-layout="${args['alt-mobile-layout']}"
    search-form="${args['search-form']}"
    nav-lang="${args['nav-lang']}"
    country-code="${args['country-code']}"
    active-lang="${args['active-lang']}"
    phone-no="${args['phone-no']}"
    home-link="${args['home-link']}"
  >
    <cradlepoint-search-form
      slot="search-form"
      class="hidden"
    ></cradlepoint-search-form>
    <cradlepoint-nav-lang
      slot="nav-lang"
      class="hidden"
      json="https://corsproxy.io/?https%3A%2F%2Fcradlepoint.com%2Fwp-content%2Fuploads%2Fcradlepoint-theme-settings%2Ftheme-settings.json"
    ></cradlepoint-nav-lang>
  </cradlepoint-nav-main>
`;

export const Default = Template.bind({});

Default.args = {
  json: 'https://corsproxy.io/?https%3A%2F%2Fcradlepoint.com%2Fwp-content%2Fuploads%2Fcradlepoint-posts-json%2Fpost-15867.json',
  logo: 'https://img.cradlepoint.com/auto-mapping-folder/2022/07/cradlepoint-po-ericsson-logo-long-reverse.png',
  'show-contact': 'true',
  'show-search': 'true',
  'show-language-nav': 'true',
  'show-sign-in': 'true',
  'alt-mobile-layout': 'true',
  'search-form': 'cradlepoint-search-form',
  'nav-lang': 'cradlepoint-nav-lang',
  'country-code' : "US",
  'active-lang' : "English",
  'phone-no' : "1-855-813-3385",
  'home-link' : "/",
}
